import { Button, Tooltip, Typography, Stack } from '@cast/design-system';
import { useAbility } from '@cast/shared-ability-data-access';

import { useProvisionNodesDrawer } from 'features/cluster/autoscaler/edge-locations/_hooks';
import { useIsClusterOmniEnabled } from 'features/cluster/autoscaler/edge-locations/hooks';
import { useOmniAvailableRegionsFeatureEnabled } from 'features/cluster/autoscaler/edge-locations/hooks/useOmniAvailableRegionsFeatureEnabled';
import { useAssignOmniCredentialsDialog } from 'hooks/dialogs/cluster/assign-credentials/useAssignOmniCredentialsDialog';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const ProvisionEdgeNodeButton = () => {
  const isOmniAvailableRegionsEnabled = useOmniAvailableRegionsFeatureEnabled();
  const { openProvisionNodesDrawer } = useProvisionNodesDrawer();
  const { cluster } = useCluster();
  const { isClusterOmniEnabled } = useIsClusterOmniEnabled({
    clusterId: cluster.id,
  });
  const { openOmniCredentialsDialog } = useAssignOmniCredentialsDialog();
  const canCreateNode = useAbility().can('create', 'ClusterNodes');

  if (isOmniAvailableRegionsEnabled) {
    return null;
  }

  const isDisabled = !isClusterOmniEnabled || !canCreateNode;

  return (
    <Tooltip
      wrapIf={isDisabled}
      title={
        <Stack gap={4}>
          <Typography variant="P12R">
            {!isClusterOmniEnabled
              ? 'Enable Omni to provision nodes.'
              : 'You do not have permission to provision nodes.'}
          </Typography>
          {!isClusterOmniEnabled && (
            <Button
              variant="text"
              size="sm"
              onClick={() => openOmniCredentialsDialog({ cluster })}
            >
              Enable Omni
            </Button>
          )}
        </Stack>
      }
    >
      <span>
        <Button
          size="sm"
          variant="secondary"
          testId="provision-edge-node-button"
          disabled={isDisabled}
          onClick={() =>
            openProvisionNodesDrawer({
              clusterId: cluster.id,
            })
          }
        >
          Provision edge node
        </Button>
      </span>
    </Tooltip>
  );
};
